import { randoms } from "lib/utils";


export const statementBoilerplate = {
  refstr: randoms.string(12, "a#"),
  title: "New statement",
  description: "",
  visible: true,
  if_passes: "",
  if_fails: "",
  nested: {
    if_passes: null,
    if_fails: null
  },
  conditional: {
    source_id: null,
    name: "Conditional Statement",
    description: "",
    zones: [],
    items: [],
    clipboard: []
  },
  content: {
    pass: "",
    fail: ""
  },
  parent: [
    "[root]"
  ],
  level: 1,
  parentResult: "any"
}